import { OperationVariables } from '@apollo/client'

export const MAX_PAGINATION_LIMIT = 100

function toNumber(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) ? value : null
}

export function clampPaginationLimit(limit: number = MAX_PAGINATION_LIMIT): number {
  if (!Number.isFinite(limit)) {
    return MAX_PAGINATION_LIMIT
  }

  return Math.min(limit, MAX_PAGINATION_LIMIT)
}

function clampVariablesLimitByRoot(
  variables: OperationVariables | undefined,
  rootKey: 'input' | 'request',
): OperationVariables | undefined {
  if (!variables) {
    return variables
  }

  const rootValue = variables[rootKey]
  if (!rootValue || typeof rootValue !== 'object') {
    return variables
  }

  const root = rootValue as Record<string, unknown>
  const hasPaginationShape = Object.prototype.hasOwnProperty.call(root, 'skip') || 'limit' in root

  if (!hasPaginationShape) {
    return variables
  }

  const currentLimit = toNumber(root.limit)
  const nextLimit = clampPaginationLimit(currentLimit ?? MAX_PAGINATION_LIMIT)

  if (currentLimit === nextLimit) {
    return variables
  }

  return {
    ...variables,
    [rootKey]: {
      ...root,
      limit: nextLimit,
    },
  }
}

export function clampClientsPaginationVariables(
  operationName: string | undefined,
  variables: OperationVariables | undefined,
): OperationVariables | undefined {
  if (!operationName || !/(client|customer)/i.test(operationName)) {
    return variables
  }

  return clampVariablesLimitByRoot(clampVariablesLimitByRoot(variables, 'input'), 'request')
}
